/* ------------------------------------------------------------------
   Favoriler — uygulamasiz, localStorage tabanli.

   Anahtar : numtex:favoriler
   Deger   : JSON dizisi, urun HANDLE'lari, en yeni basta.
             ornek -> ["siyah-oversize-tshirt","favela-hoodie"]

   Kalp butonu SUNUCU TARAFINDA basilir (snippets/favori-kalp.liquid).
   Bu dosya yalnizca durumu yansitir, hicbir kalbi DOM'a enjekte etmez —
   boylece ilk boyamada ziplama olmaz.

   Header rozeti ise DOM ile eklenir: sections/header.liquid'e
   dokunulmuyor. Baglanma noktasi:
       ul.header__utils-items > li.header__utils-item--cart  (oncesine)

   Ortam notu: olcum tarayicisinda IntersectionObserver ve
   requestAnimationFrame geri cagrilari tetiklenmiyor. Bu dosya ikisini de
   KULLANMAZ; tazeleme MutationObserver + setTimeout ile yapilir.
   ------------------------------------------------------------------ */

(function () {
  'use strict';

  // Ayni dosya birden fazla kartta <script> ile baglanabiliyor.
  // Ikinci calistirma hicbir sey yapmasin, dinleyiciler ciftlenmesin.
  if (window.NumtexFavoriler) return;

  var ANAHTAR = 'numtex:favoriler';
  var EN_FAZLA = 250; // kota tasmasina karsi ust sinir
  var FAVORILER_YOLU = 'pages/favoriler';

  var KALP_PATH =
    'M12 20.4s-7.6-4.6-7.6-10.1a4.3 4.3 0 0 1 7.6-2.7 4.3 4.3 0 0 1 7.6 2.7c0 5.5-7.6 10.1-7.6 10.1Z';

  /* ---------------- Depolama ---------------- */

  function kok() {
    var r =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function oku() {
    var ham;
    try {
      ham = window.localStorage.getItem(ANAHTAR);
    } catch (e) {
      // localStorage kapali (gizli sekme / 3. taraf cerez engeli)
      return [];
    }
    if (!ham) return [];

    var veri;
    try {
      veri = JSON.parse(ham);
    } catch (e) {
      sifirla();
      return [];
    }
    if (!Array.isArray(veri)) {
      sifirla();
      return [];
    }
    // Bozuk/eksik kayitlari at, tekrarlari temizle
    var temiz = [];
    for (var i = 0; i < veri.length; i++) {
      var h = veri[i];
      if (typeof h === 'string' && h && temiz.indexOf(h) === -1) temiz.push(h);
    }
    return temiz;
  }

  function sifirla() {
    try {
      window.localStorage.removeItem(ANAHTAR);
    } catch (e) {
      /* yapacak bir sey yok */
    }
  }

  function yaz(liste) {
    if (liste.length > EN_FAZLA) liste = liste.slice(0, EN_FAZLA);
    try {
      window.localStorage.setItem(ANAHTAR, JSON.stringify(liste));
      return true;
    } catch (e) {
      // Kota tasmasi: yariya indirip bir kez daha dene.
      try {
        window.localStorage.setItem(
          ANAHTAR,
          JSON.stringify(liste.slice(0, Math.floor(liste.length / 2)))
        );
        return true;
      } catch (e2) {
        return false;
      }
    }
  }

  function varMi(handle) {
    return oku().indexOf(handle) !== -1;
  }

  function degistir(handle) {
    var liste = oku();
    var yer = liste.indexOf(handle);
    var eklendi;
    if (yer === -1) {
      liste.unshift(handle);
      eklendi = true;
    } else {
      liste.splice(yer, 1);
      eklendi = false;
    }
    yaz(liste);
    yansit();
    document.dispatchEvent(
      new CustomEvent('favoriler:degisti', {
        detail: { handle: handle, eklendi: eklendi, adet: liste.length }
      })
    );
    return eklendi;
  }

  function cikar(handle) {
    var liste = oku();
    var yer = liste.indexOf(handle);
    if (yer === -1) return false;
    liste.splice(yer, 1);
    yaz(liste);
    yansit();
    document.dispatchEvent(
      new CustomEvent('favoriler:degisti', {
        detail: { handle: handle, eklendi: false, adet: liste.length }
      })
    );
    return true;
  }

  /* ---------------- Kalp durumu ---------------- */

  function kalbiTazele(dugme, liste) {
    var handle = dugme.getAttribute('data-favori-handle');
    if (!handle) return;
    var dolu = liste.indexOf(handle) !== -1;
    var suanki = dugme.getAttribute('aria-pressed') === 'true';
    if (suanki === dolu && dugme.classList.contains('is-favori') === dolu) return;

    dugme.setAttribute('aria-pressed', dolu ? 'true' : 'false');
    dugme.classList.toggle('is-favori', dolu);
    dugme.setAttribute(
      'aria-label',
      dolu ? 'Favorilerden çıkar' : 'Favorilere ekle'
    );
    var gizli = dugme.querySelector('[data-favori-metin]');
    if (gizli) gizli.textContent = dolu ? 'Favorilerden çıkar' : 'Favorilere ekle';
  }

  function yansit() {
    var liste = oku();
    var kalpler = document.querySelectorAll('[data-favori-kalp]');
    for (var i = 0; i < kalpler.length; i++) kalbiTazele(kalpler[i], liste);
    rozetiKur(liste.length);
  }

  /* ---------------- Header rozeti ---------------- */

  function rozetSvg(sinif) {
    return (
      '<svg class="' +
      sinif +
      '" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="' +
      KALP_PATH +
      '"/></svg>'
    );
  }

  function rozetiKur(adet) {
    // header_utils birden fazla kez basilabiliyor (mobil/masaustu/ek linkli
    // varyant), bu yuzden TUM sepet ogelerinin oncesine ekleniyor.
    var sepetler = document.querySelectorAll(
      '.header__utils-items .header__utils-item--cart'
    );
    for (var i = 0; i < sepetler.length; i++) {
      var sepet = sepetler[i];
      var liste = sepet.parentNode;
      if (!liste) continue;

      var oge = liste.querySelector('.header__utils-item--favori');
      if (!oge) {
        oge = document.createElement('li');
        oge.className =
          'header__utils-item header__utils-item--favori header__utils-item--mobile';
        oge.innerHTML =
          '<a href="' +
          kok() +
          FAVORILER_YOLU +
          '" class="header__utils-link text-link" title="Favorilerim">' +
          '<span class="header__utils-link--icon text-link--on-hover">' +
          rozetSvg('favori-header__ikon') +
          '<span class="favori-rozet" data-favori-rozet hidden></span>' +
          '</span>' +
          '<span class="visually-hidden">Favorilerim</span>' +
          '</a>';
        liste.insertBefore(oge, sepet);
      }

      var baglanti = oge.querySelector('.header__utils-link');
      var rozet = oge.querySelector('[data-favori-rozet]');
      if (rozet) {
        rozet.textContent = adet > 99 ? '+' : String(adet);
        if (adet > 0) rozet.removeAttribute('hidden');
        else rozet.setAttribute('hidden', '');
      }
      if (baglanti) baglanti.classList.toggle('is-dolu', adet > 0);
    }
  }

  /* ---------------- Tiklama ---------------- */

  // Yakalama (capture) evresinde dinleniyor: kalp kart linkinin DISINDA
  // dursa bile, ic ice bir kullanimda linkin gezinmesini kesmek gerekiyor.
  document.addEventListener(
    'click',
    function (olay) {
      var dugme = olay.target && olay.target.closest
        ? olay.target.closest('[data-favori-kalp]')
        : null;
      if (!dugme) return;

      olay.preventDefault();
      olay.stopPropagation();

      var handle = dugme.getAttribute('data-favori-handle');
      if (!handle) return;

      var eklendi = degistir(handle);
      if (eklendi) {
        dugme.classList.remove('is-nabiz');
        // sinifi yeniden eklemek icin bir tur bekle (animasyon tekrar bassin)
        setTimeout(function () {
          dugme.classList.add('is-nabiz');
        }, 0);
        setTimeout(function () {
          dugme.classList.remove('is-nabiz');
        }, 600);
      }

      // Favoriler sayfasindaysak karti listeden dusur
      var kart = dugme.closest('[data-favori-kart]');
      if (kart && !eklendi) {
        kart.parentNode && kart.parentNode.removeChild(kart);
        sayfaOzetiTazele();
      }
    },
    true
  );

  // Baska sekmede degisirse burasi da guncellensin
  window.addEventListener('storage', function (olay) {
    if (olay.key === ANAHTAR) yansit();
  });

  /* ---------------- Yeniden basilan kartlar ---------------- */

  // Koleksiyon filtresi, varyant degisimi ve "daha fazla yukle" kartlari
  // yeniden basiyor. rAF/IntersectionObserver bu ortamda tetiklenmedigi icin
  // MutationObserver + setTimeout ile kisitlaniyor.
  var bekleyen = null;
  function tazeleKisitli() {
    if (bekleyen) return;
    bekleyen = setTimeout(function () {
      bekleyen = null;
      yansit();
    }, 60);
  }

  function gozlemeBasla() {
    if (!document.body) return;
    try {
      new MutationObserver(tazeleKisitli).observe(document.body, {
        childList: true,
        subtree: true
      });
    } catch (e) {
      /* gozlemci yoksa ilk yansitma yine de calisti */
    }
  }

  /* ---------------- Para bicimi ---------------- */

  function bolumle(sayi, ondalikAyraci, binlikAyraci, basamak) {
    if (isNaN(sayi) || sayi === null) return '0';
    var deger = (sayi / 100).toFixed(basamak);
    var parca = deger.split('.');
    var tam = parca[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + binlikAyraci);
    var kusur = parca[1] ? ondalikAyraci + parca[1] : '';
    return tam + kusur;
  }

  function paraFormatla(kurus) {
    var bicim =
      (window.theme &&
        window.theme.settings &&
        window.theme.settings.money_format) ||
      '{{amount}}';
    var eslesme = bicim.match(/\{\{\s*(\w+)\s*\}\}/);
    var tur = eslesme ? eslesme[1] : 'amount';
    var deger;

    switch (tur) {
      case 'amount_no_decimals':
        deger = bolumle(kurus, '.', ',', 0);
        break;
      case 'amount_with_comma_separator':
        deger = bolumle(kurus, ',', '.', 2);
        break;
      case 'amount_no_decimals_with_comma_separator':
        deger = bolumle(kurus, ',', '.', 0);
        break;
      case 'amount_with_apostrophe_separator':
        deger = bolumle(kurus, '.', "'", 2);
        break;
      default:
        deger = bolumle(kurus, '.', ',', 2);
    }
    return bicim.replace(/\{\{\s*\w+\s*\}\}/, deger);
  }

  /* ---------------- /pages/favoriler ---------------- */

  function gorselBoyutlu(url, genislik) {
    if (!url) return '';
    var tam = url.indexOf('//') === 0 ? 'https:' + url : url;
    return tam + (tam.indexOf('?') === -1 ? '?' : '&') + 'width=' + genislik;
  }

  function kartYap(urun) {
    var li = document.createElement('li');
    li.className = 'favoriler-kart';
    li.setAttribute('data-favori-kart', '');
    li.setAttribute('data-handle', urun.handle);

    var url = kok() + 'products/' + urun.handle;
    var gorsel = urun.featured_image || (urun.images && urun.images[0]) || '';

    var fiyat = paraFormatla(urun.price);
    var karsilastirma =
      urun.compare_at_price && urun.compare_at_price > urun.price
        ? '<del>' + paraFormatla(urun.compare_at_price) + '</del>'
        : '';

    li.innerHTML =
      '<a class="favoriler-kart__gorsel-baglanti" href="' +
      url +
      '">' +
      (gorsel
        ? '<img class="favoriler-kart__gorsel" src="' +
          gorselBoyutlu(gorsel, 600) +
          '" alt="' +
          escapeAttr(urun.title) +
          '" loading="lazy" width="600" height="800">'
        : '<span class="favoriler-kart__gorsel"></span>') +
      '</a>' +
      '<div class="favoriler-kart__govde">' +
      '<h3 class="favoriler-kart__baslik"><a href="' +
      url +
      '">' +
      escapeHtml(urun.title) +
      '</a></h3>' +
      '<span class="favoriler-kart__fiyat">' +
      karsilastirma +
      fiyat +
      '</span>' +
      (urun.available
        ? ''
        : '<span class="favoriler-kart__tukendi">Tükendi</span>') +
      '</div>';

    // Kalp: kart gorselinin sag ustunde, linkin DISINDA
    var kalp = document.createElement('button');
    kalp.type = 'button';
    kalp.className = 'favori-kalp favori-kalp--kart is-favori';
    kalp.setAttribute('data-favori-kalp', '');
    kalp.setAttribute('data-favori-handle', urun.handle);
    kalp.setAttribute('aria-pressed', 'true');
    kalp.setAttribute('aria-label', 'Favorilerden çıkar');
    kalp.innerHTML =
      '<span class="favori-kalp__daire">' +
      rozetSvg('favori-kalp__ikon') +
      '</span>';
    li.insertBefore(kalp, li.firstChild);

    return li;
  }

  function escapeHtml(metin) {
    var d = document.createElement('div');
    d.textContent = metin == null ? '' : String(metin);
    return d.innerHTML;
  }

  // Oznitelik icine giren metinde tirnak da kacilmali; innerHTML tirnagi
  // kacirmaz, tek basina kullanmak alt="" degerini kirar.
  function escapeAttr(metin) {
    return escapeHtml(metin).replace(/"/g, '&quot;');
  }

  function bosDurum() {
    return (
      '<div class="favoriler-bos">' +
      '<svg class="favoriler-bos__ikon" viewBox="0 0 24 24" aria-hidden="true"><path d="' +
      KALP_PATH +
      '"/></svg>' +
      '<h2 class="favoriler-bos__baslik h4">Favori listeniz henüz boş</h2>' +
      '<p class="favoriler-bos__metin">Beğendiğiniz ürünlerin sağ üstündeki kalbe dokunun; ' +
      'burada toplansın, sonra rahatça karar verin.</p>' +
      '<a class="favoriler-bos__buton" href="' +
      kok() +
      'collections/all">Ürünleri keşfet</a>' +
      '</div>'
    );
  }

  function sayfaOzetiTazele() {
    var kap = document.querySelector('[data-favoriler-sayfa]');
    if (!kap) return;
    var izgara = kap.querySelector('.favoriler-sayfa__izgara');
    var ozet = kap.querySelector('[data-favoriler-ozet]');
    var adet = izgara ? izgara.children.length : 0;

    if (adet === 0) {
      // Ozet paragrafi da gitsin; yoksa bos durumun ustunde bos bir satir kalir.
      kap.innerHTML = bosDurum();
      return;
    }
    if (ozet) ozet.textContent = adet + ' ürün';
  }

  function sayfayiKur() {
    var kap = document.querySelector('[data-favoriler-sayfa]');
    if (!kap) return;

    var liste = oku();
    if (!liste.length) {
      kap.innerHTML = bosDurum();
      return;
    }

    kap.innerHTML =
      '<p class="favoriler-sayfa__ozet" data-favoriler-ozet>Yükleniyor…</p>' +
      '<ul class="favoriler-sayfa__izgara"></ul>';
    var izgara = kap.querySelector('.favoriler-sayfa__izgara');

    var istekler = liste.map(function (handle) {
      return fetch(kok() + 'products/' + handle + '.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (y) {
          if (y.status === 404 || y.status === 410) return { yok: true, handle: handle };
          if (!y.ok) return { hata: true, handle: handle };
          return y.json().then(
            function (u) {
              return { urun: u, handle: handle };
            },
            function () {
              return { yok: true, handle: handle };
            }
          );
        })
        .catch(function () {
          // Ag hatasi silme sebebi DEGIL — handle listede kalsin.
          return { hata: true, handle: handle };
        });
    });

    Promise.all(istekler).then(function (sonuclar) {
      var silinecek = [];
      var basildi = 0;

      sonuclar.forEach(function (s) {
        if (s.yok) {
          silinecek.push(s.handle);
          return;
        }
        if (s.hata || !s.urun) return;
        izgara.appendChild(kartYap(s.urun));
        basildi++;
      });

      // Silinmis urunu listeden kendiliginden dusur
      if (silinecek.length) {
        var kalan = oku().filter(function (h) {
          return silinecek.indexOf(h) === -1;
        });
        yaz(kalan);
        yansit();
      }

      var ozet = kap.querySelector('[data-favoriler-ozet]');
      if (ozet) ozet.textContent = basildi ? basildi + ' ürün' : '';
      if (!basildi) {
        kap.innerHTML = bosDurum();
      }
    });
  }

  /* ---------------- Baslat ---------------- */

  function baslat() {
    yansit();
    gozlemeBasla();
    sayfayiKur();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }

  window.NumtexFavoriler = {
    anahtar: ANAHTAR,
    oku: oku,
    varMi: varMi,
    degistir: degistir,
    cikar: cikar,
    yansit: yansit,
    paraFormatla: paraFormatla
  };
})();
